import type { SVGProps } from "react";
const SvgRotate = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
        <path
            fill="currentColor"
            d="M10.398 8.098c1.031 0 1.867.836 1.867 1.867v4.668a1.867 1.867 0 0 1-1.867 1.867H3.397a1.867 1.867 0 0 1-1.867-1.867V9.965c0-1.03.836-1.867 1.867-1.867zM8.36 1.504a.62.62 0 0 1 .524.444l.36 1.254a5.6 5.6 0 0 1 7.223 5.362.934.934 0 0 1-1.865.07l-.003-.069a3.734 3.734 0 0 0-4.841-3.567l.41 1.43a.62.62 0 0 1-.893.712L6.392 5.542a.617.617 0 0 1-.24-.84l1.597-2.883a.62.62 0 0 1 .611-.315"
        />
    </svg>
);
export default SvgRotate;
